import React from 'react';
import { NextPageLabel } from './next-page-label';
import { PageButton } from './page-button';
import { PageButtons } from './page-buttons';
import * as S from './pagination.styles';
import { PrevPageLabel } from './prev-page-label';
export const Pagination = ({ currentPage, itemsPerPage, totalResults, onChange, isDisabled, prevPageLabel, nextPageLabel, }) => {
    // Use the pages prop, or else calculate the total pages by dividing the total results by the items per page.
    const totalPages = Math.ceil(totalResults / itemsPerPage);
    // Don't render anything if there is only 1 page.
    if (totalPages <= 1)
        return null;
    return (React.createElement(S.Pagination, { "data-testid": "pagination" },
        currentPage > 1 && (React.createElement(PageButton, { page: currentPage - 1, onClick: onChange, label: React.createElement(PrevPageLabel, { label: prevPageLabel }), isDisabled: isDisabled, testId: "pagination-btn-prev", 
            // Add a class so we can easily style this button om mobile view.
            className: "prev" })),
        React.createElement(PageButtons, { currentPage: currentPage, totalPages: totalPages, onChange: onChange, isDisabled: isDisabled }),
        currentPage < totalPages && (React.createElement(PageButton, { page: currentPage + 1, onClick: onChange, label: React.createElement(NextPageLabel, { label: nextPageLabel }), isDisabled: isDisabled, testId: "pagination-btn-next", 
            // Add a class so we can easily style this button om mobile view.
            className: "next" }))));
};
//# sourceMappingURL=pagination.js.map